/* eslint-disable no-use-before-define */
import { FC, useEffect, useState } from 'react';
import { Paragrapth } from '@orientaction/components';
import useStyles from './style';
import { MarginContainer } from '@orientaction/commons';

interface IArrayYouContext {
    objectList: any;
}

const ArrayYouContext: FC<IArrayYouContext> = ({ objectList }) => {


    const classes = useStyles();

    const title = Object.keys(objectList);

    return (
        <div
            style={{
                display: 'table-row',
            }}
        >

            {
                title.map((currentObject: any, titleIndex: number) =>
                    <div
                        key={objectList[currentObject].label ?? titleIndex}
                        className={classes.tableContainer}
                    >

                        <div className={classes.head}>
                            {objectList[currentObject].label || ""}
                        </div>

                        <div
                            className={classes.body}
                        >

                            {(objectList[currentObject].listParagraph || []).map((item: any) =>
                                <MarginContainer key={`${currentObject}-${item}`}>
                                    <Paragrapth align='justify'>
                                        {item || ''}
                                    </Paragrapth>
                                </MarginContainer>
                            ) || ""}

                        </div>

                    </div>
                )
            }

        </div>
    );

};

export default ArrayYouContext;
